export enum VatMode {
    Fixed = "Fixed",
    Disabled = "Disabled",
    FromProduct = "FromProduct"
}
